<p class="field-label">{{ label }}</p>
<p>{{ detail }}</p>
